import { render, staticRenderFns } from "./reminderText.vue?vue&type=template&id=bd329c22&scoped=true"
import script from "./reminderText.vue?vue&type=script&lang=js"
export * from "./reminderText.vue?vue&type=script&lang=js"
import style0 from "./reminderText.vue?vue&type=style&index=0&id=bd329c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd329c22",
  null
  
)

export default component.exports